import React from 'react';
import { Heading } from '@thd-olt-component-react/core-ui';
import { shape, string } from 'prop-types';

export const ProductCategoryContent = ({ content }) => {
  if (!content || !content?.title || !content?.data) return null;
  return (
    <div>
      <Heading level="1" title={content?.title} underline />
      <div dangerouslySetInnerHTML={{ __html: content?.data }} />
    </div>
  );
};

ProductCategoryContent.propTypes = {
  content: shape({
    title: string,
    data: string
  })
};

ProductCategoryContent.defaultProps = {
  content: null
};
